/*
 *
 * ReportAdmin actions
 *
 */

import {
  GET_TEAMS_WATCHER,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_FAILED,
} from "./constants"

export function getTeamsWatcher(payload) {
  return {
    type: GET_TEAMS_WATCHER,
    payload,
  }
}

export function getTeamsSuccess(payload) {
  return {
    type: GET_TEAMS_SUCCESS,
    payload,
  }
}

export function getTeamsFailed() {
  return { type: GET_TEAMS_FAILED }
}
